import React, { useEffect, useState } from 'react';
import {
  Alert,
  AlertTitle,
  Button,
  Checkbox,
  FormControlLabel,
  Skeleton,
  Stack,
} from '@mui/material';
import { MultiCountrySelector } from '@marageti/z4-lib';
import { useMatchingStore } from '../../store';

const PartnersSearch = () => {
  const {
    cooperativeMatch,
    setCooperativeMatch,
    setSelectedCountries,
    tripRequest,
  } = useMatchingStore();
  const tripRequestCountries = tripRequest?.countries;

  const countryOptions = tripRequestCountries ? tripRequestCountries.map((c) => ({ country: c })) : [];
  // The available destinations are limited to those in the trip request
  // The trip request must be edited to add other destinations
  const [selectorValue, setSelectorValue] = useState<string[] | undefined>(tripRequestCountries);

  useEffect(() => {
    if (tripRequestCountries) setSelectorValue(tripRequestCountries);
  }, [tripRequestCountries]);

  const onChange = (_: any, data: string[]) => {
    setSelectorValue(data);
  };

  const onSubmit = () => {
    setSelectedCountries(selectorValue);
  };

  return tripRequestCountries ? (
    <>
      <Stack spacing={2} direction={{ desktop: 'row' }} mb={{ mobile: 2, desktop: 1 }} maxWidth="450px" alignItems="flex-end">
        <MultiCountrySelector
          key="country-select"
          label="Country"
          onChange={onChange}
          countries={countryOptions}
          value={selectorValue}
        />
        <Button
          onClick={onSubmit}
          variant="contained"
          sx={{
            height: '43px',
            mb: { desktop: '10px !important' },
            mt: { mobile: 0.75, desktop: 0 },
            width: { mobile: '100%', desktop: 'fit-content' },
          }}
        >
          Search
        </Button>
      </Stack>
      <FormControlLabel
        control={(
          <Checkbox
            checked={cooperativeMatch}
            onChange={() => setCooperativeMatch(!cooperativeMatch)}
            size="small"
          />
      )}
        label="Cooperative Match"
        sx={{ mb: 3 }}
      />
      {cooperativeMatch && (
        <Alert severity="info" sx={{ mb: 3 }}>
          <AlertTitle>Cooperative Match</AlertTitle>
          The traveler will work with multiple partners to plan different segments of this trip.
        </Alert>
      )}
    </>
  ) : <Skeleton variant="rounded" height={140} />;
};

export default PartnersSearch;
